export enum UserRoles {
    System = 'System', //tooling - don't use
    DnsSupport = 'DnsSupport', //tooling - don't use
    SysAdmin = 'SysAdmin', //tooling - don't use
    Sl2Support = 'Sl2Support',
    Sl3Support = 'Sl3Support',
    WebSupport = 'WebSupport',
    TechSupport = 'TechSupport',
    SiteOwner = 'SiteOwner', //don't use
    ManageUsers = 'ManageUsers',
    TeamLeader = 'TeamLeader', //still used?
    CrmAdmin = 'CrmAdmin',
    CrmUser = 'CrmUser',
    CrmViewer = 'CrmViewer',
    CrmPowerUser = 'CrmPowerUser',
    MyLeads = 'MyLeads',
    MyLeadsReadOnly = 'MyLeadsReadOnly',
    MyListings = 'MyListings',
    MySites = 'MySites',
    MyCampaigns = 'MyCampaigns',
}

/*
    Permission groups based on user role
 */
export const userRoles = {
    all: [
        UserRoles.WebSupport,
        UserRoles.TechSupport,
        UserRoles.Sl2Support,
        UserRoles.Sl3Support,
        UserRoles.DnsSupport,
        UserRoles.SysAdmin,
        UserRoles.SiteOwner,
        UserRoles.ManageUsers,
        UserRoles.TeamLeader,
        UserRoles.CrmAdmin,
        UserRoles.CrmUser,
        UserRoles.CrmViewer,
        UserRoles.CrmPowerUser,
        UserRoles.MyLeads,
        UserRoles.MyLeadsReadOnly,
        UserRoles.MyListings,
        UserRoles.MySites,
        UserRoles.MyCampaigns,
    ],
    support: [
        UserRoles.WebSupport,
        UserRoles.TechSupport,
        UserRoles.Sl2Support,
        UserRoles.Sl3Support,
        UserRoles.DnsSupport,
        UserRoles.SysAdmin,
    ],
    techSupport: [UserRoles.TechSupport, UserRoles.Sl3Support, UserRoles.Sl2Support],
    users: [
        UserRoles.CrmAdmin,
        UserRoles.CrmUser,
        UserRoles.CrmViewer,
        UserRoles.CrmPowerUser,
        UserRoles.MyLeads,
        UserRoles.MyLeadsReadOnly,
        UserRoles.MyListings,
        UserRoles.MySites,
        UserRoles.MyCampaigns,
    ],
    admins: [UserRoles.CrmAdmin, UserRoles.SiteOwner],
};

export const userAssignableRoles = [
    UserRoles.CrmAdmin,
    UserRoles.ManageUsers,
    UserRoles.MyLeads,
    UserRoles.MyLeadsReadOnly,
    UserRoles.MyCampaigns,
    UserRoles.MySites,
    UserRoles.MyListings,
];

export function getFriendlyRoleName(role: UserRoles): string {
    switch (role) {
        case UserRoles.System:
            return 'System';
        case UserRoles.SysAdmin:
            return 'System Admin';
        case UserRoles.DnsSupport:
            return 'DNS Support';
        case UserRoles.TechSupport:
            return 'Tech Support';
        case UserRoles.WebSupport:
            return 'Web Support';
        case UserRoles.Sl2Support:
            return 'SL2 Support';
        case UserRoles.Sl3Support:
            return 'SL3 Support';
        case UserRoles.SiteOwner:
            return 'Site Owner';
        case UserRoles.CrmAdmin:
            return 'CRM Admin';
        case UserRoles.TeamLeader:
            return 'Team Leader';
        case UserRoles.ManageUsers:
            return 'Manage Users';
        case UserRoles.MyLeads:
            return 'Manage Contacts';
        case UserRoles.MyLeadsReadOnly:
            return 'View Contacts (Read Only)';
        case UserRoles.MyCampaigns:
            return 'Manage Campaigns';
        case UserRoles.MySites:
            return 'Manage Websites';
        case UserRoles.MyListings:
            return 'Manage Listings';
        case UserRoles.CrmPowerUser:
            return 'CRM Power User';
        case UserRoles.CrmUser:
            return 'CRM User';
        case UserRoles.CrmViewer:
            return 'CRM Viewer';
        default:
            return 'Unknown Role';
    }
}
